module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buy"
  }, [(_vm.isShow) ? _c('div', {
    staticClass: "fixed-bar-yyfw"
  }, [(_vm.h5) ? _c('a', {
    attrs: {
      "id": "reserv-service-about",
      "href": _vm.yyfw
    }
  }, [_c('img', {
    attrs: {
      "src": "static/nianjinxian/images/icon_018.png",
      "width": "64"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "service"
  }, [(_vm.showPoster) ? _c('a', {
    staticClass: "dial",
    attrs: {
      "href": _vm.posterURL
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.posterIcon
    }
  }), _c('span', [_vm._v("海报")])]) : _vm._e(), _vm._v(" "), (_vm.isDailiren && _vm.inJihuashuProducts && !_vm.isProspectus) ? _c('a', {
    staticClass: "dial",
    staticStyle: {
      "padding": "0 0.25rem"
    },
    attrs: {
      "xx": _vm.isProspectus,
      "href": _vm.jihuashuURL
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.jihuashuIcon
    }
  }), _c('span', [_vm._v("计划书")])]) : _vm._e(), _vm._v(" "), (!_vm.h5) ? _c('a', {
    staticClass: "dial",
    attrs: {
      "id": "tel-ask-about",
      "href": 'tel:' + _vm.tel
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.phoneIcon
    }
  }), _c('span', [_vm._v("客服")])]) : _vm._e(), _vm._v(" "), (_vm.h5) ? _c('a', {
    staticClass: "dial",
    attrs: {
      "id": "online-ask-about",
      "href": _vm.online
    }
  }, [_c('img', {
    attrs: {
      "src": "static/nianjinxian/images/icon_019.png"
    }
  }), _c('span', [_vm._v("在线咨询")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('p', [_vm._v("价格: "), (_vm.measureState && _vm.measureSuccess === false) ? _c('span', [_c('i', {
    staticClass: "number"
  }, [_vm._v("暂无")])]) : _c('span', [_vm._v("￥"), _c('i', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.number))]), _vm._v("/" + _vm._s(_vm.paymentUnit)), (_vm.measureSuccess === '' || _vm.measureState === false) ? _c('i', [_vm._v(" 起")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "btn theme-bg-color",
    on: {
      "click": function () {
        this$1.$emit('clickBuy')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.buyName))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f70fbea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Buy.vue
// module id = 686
// module chunks = 1